// extracted by mini-css-extract-plugin
export var carrierTab = "_5q-0";
export var carrierTabActive = "_5q-1 _5q-0";
export var carrierTabInactive = "_5q-2 _5q-0";
export var carrierTabLabel = "_5q-3";
export var carrierTabLabelActive = "_5q-4 _5q-3";
export var carrierTabLabelInactive = "_5q-5 _5q-3";
export var carrierTabPercentage = "_5q-6";
export var carrierTabPercentageActive = "_5q-7 _5q-6";
export var carrierTabPercentageInactive = "_5q-8 _5q-6";
export var carrierTabWinnable = "_5q-9";
export var carrierTabWinnableActive = "_5q-a _5q-9";
export var carrierTabWinnableInactive = "_5q-b _5q-9";
export var comparisonContainer = "_5q-d";
export var missingRateButton = "_5q-n";
export var missingRateButtonActive = "_5q-o _5q-n";
export var missingRateButtonInactive = "_5q-p _5q-n";
export var missingRateButtonLabel = "_5q-q";
export var missingRateButtonLabelActive = "_5q-r _5q-q";
export var missingRateButtonLabelInactive = "_5q-s _5q-q";
export var sidebar = "_5q-c";
export var strategyButton = "_5q-e";
export var strategyButtonActive = "_5q-f _5q-e";
export var strategyButtonDescription = "_5q-k";
export var strategyButtonDescriptionActive = "_5q-l _5q-k";
export var strategyButtonDescriptionInactive = "_5q-m _5q-k";
export var strategyButtonInactive = "_5q-g _5q-e";
export var strategyButtonLabel = "_5q-h";
export var strategyButtonLabelActive = "_5q-i _5q-h";
export var strategyButtonLabelInactive = "_5q-j _5q-h";
export var unitToggleButton = "_5q-t";
export var unitToggleButtonActive = "_5q-u _5q-t";
export var unitToggleButtonInactive = "_5q-v _5q-t";
export var unitToggleButtonLabel = "_5q-w";
export var unitToggleButtonLabelActive = "_5q-x _5q-w";
export var unitToggleButtonLabelInactive = "_5q-y _5q-w";